import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { AnalyticsInsightReportFeedbackSchema_ } from "./analytics-insight-report-feedback-schema";

const ProvideInsightReportFeedbackInputSchema = z.object({
  reportId: zExt.objectId(),
  feedback: AnalyticsInsightReportFeedbackSchema_.omit({ userId: true }),
});

const ProvideInsightReportFeedbackOutputSchema = z.object({
  success: z.boolean(),
});

export const provideInsightReportFeedback = {
  name: "provideInsightReportFeedback" as const,
  input: ProvideInsightReportFeedbackInputSchema,
  output: ProvideInsightReportFeedbackOutputSchema,
};
